// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MultilingualString } from "./MultilingualString";
import {
  MultilingualStringFromJSON,
  MultilingualStringFromJSONTyped,
  MultilingualStringToJSON,
  MultilingualStringToJSONTyped,
} from "./MultilingualString";

/**
 *
 * @export
 * @interface ContactInfo
 */
export interface ContactInfo {
  /**
   *
   */
  organisationObject: MultilingualString;
  /**
   *
   */
  role: string;
  /**
   *
   */
  email: string;
}

/**
 * Check if a given object implements the ContactInfo interface.
 */
export function instanceOfContactInfo(value: object): value is ContactInfo {
  if (!("organisationObject" in value) || value["organisationObject"] === undefined) return false;
  if (!("role" in value) || value["role"] === undefined) return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function ContactInfoFromJSON(json: any): ContactInfo {
  return ContactInfoFromJSONTyped(json, false);
}

export function ContactInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactInfo {
  if (json == null) {
    return json;
  }
  return {
    organisationObject: MultilingualStringFromJSON(json["organisationObject"]),
    role: json["role"],
    email: json["email"],
  };
}

export function ContactInfoToJSON(json: any): ContactInfo {
  return ContactInfoToJSONTyped(json, false);
}

export function ContactInfoToJSONTyped(
  value?: ContactInfo | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    organisationObject: MultilingualStringToJSON(value["organisationObject"]),
    role: value["role"],
    email: value["email"],
  };
}
